import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Link } from 'react-router-dom'
import InputField from '../forms/input-field'
import withReduxForm from '../forms/withReduxFormField'
import CtaButton from '../buttons/cta-button'
//import CtaButtonSecondary from '../buttons/cta-button-secondary'
import NormalText from '../texts/normal-text'
import Notification from '../notifications/notification'

const Input = withReduxForm(InputField)

const renderNotification = (
  <Notification status='error' iconName='warning'>
    Wrong email or/and password, <strong>Try again.</strong>
  </Notification>
)

const LoginForm = props => {
  const { handleSubmit, submitFailed, translations } = props
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name='email'
        type='email'
        id='email'
        component={Input}
        label={translations.emailLabel}
        theme='dark-theme'
        iconName='email'
        autoFocus={true}
      />
      <Field
        name='password'
        type='password'
        id='password'
        component={Input}
        label={translations.passwordLabel}
        theme='dark-theme'
        iconName='password'
      />
      {submitFailed && renderNotification}
      <div className='form-field'>
        <CtaButton
          text={translations.logInButton}
          type='submit'
          onClick={handleSubmit}
        />
        <Link to='/forget-password' className='tiny-link'>
          {translations.forgotPasswordText}
        </Link>
      </div>
      {/*
      <div className='bottom-space top-space'>
        <CtaButtonSecondary
          hasIcon
          iconName='social-facebook'
          text={translations.faceBookSignInButton}
        />
      </div>
      */}
      <NormalText>
        {translations.noAccountText}
        <Link to='/register' className='single-link'>
          {translations.signUp}
        </Link>
      </NormalText>
    </form>
  )
}

LoginForm.defaultProps = {
  emailLabel: 'email label',
  passwordLabel: 'passwors label',
  logInButton: 'login button',
  forgotPasswordText: 'forgot password text',
  faceBookSignInButton: 'facebook sign in button',
  noAccountText: 'no account text',
  signUp: 'sign up'
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitFailed: PropTypes.bool,
  translations: PropTypes.shape({
    emailLabel: PropTypes.string.isRequired,
    passwordLabel: PropTypes.string.isRequired,
    logInButton: PropTypes.string.isRequired,
    forgotPasswordText: PropTypes.string.isRequired,
    faceBookSignInButton: PropTypes.string.isRequired,
    noAccountText: PropTypes.string.isRequired,
    signUp: PropTypes.string.isRequired
  }).isRequired
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/ui/forms/login-form.js